<script lang="ts">
    
    import type { SvelteComponent } from "svelte";
    import type { Question } from "../Model/Question";
    import QuestionGridResume from "./QuestionGridResume.svelte";
    import QuestionOptionsResume from "./QuestionOptionsResume.svelte";

    export let question: Question;

    const resumeComponentsMap = {
        grid        : QuestionGridResume,
        bool        : QuestionOptionsResume,
        multiple    : QuestionOptionsResume,
    };

    let resumeComponent: typeof SvelteComponent;

    $: setupComponent(question);

    function setupComponent(question: Question): void {
        resumeComponent = resumeComponentsMap[question.type] || null;
    }


</script>

<svelte:component this={resumeComponent} options={question.options} />
